
module.exports = {
  actionname: require('@/config/base').baseUrl + 'compete/uploadFile',
  actionname1: require('@/config/base').baseUrl + 'compete/uploadFileForCompete',
  tableDatamaxlength: 20,
  tableDatamaxlength5: 5,
  tableDatamaxlength6: 6,
  tableDatamaxlength9: 9,
  tableDatamaxlength10: 10,
  tableDatamaxlength12: 12,
  tableDatamaxlength15: 15,
  tableDatamaxlength23: 23,
  tableDatamaxlength25: 25,
  tableDatamaxlength30: 30,
  tableDatamaxlength35: 35,
  tableDatamaxlength40: 40,
  tableDatamaxlength50: 50,
  tableDatamaxlength60: 60,
  // label设置：ws带星，w不带星，数字为字号，例子：c_ws12代表表单最长label字段是带星的12个字
  c_colon: ' : ',
  c_ws1: '90px',
  c_ws2: '100px',
  c_ws3: '110px',
  c_ws4: '120px',
  c_ws5: '130px',
  c_ws6: '140px',
  c_ws7: '150px',
  c_ws8: '160px',
  c_ws9: '170px',
  c_ws10: '180px',
  c_ws11: '190px',
  c_ws12: '200px',
  c_w1: '80px',
  c_w2: '90px',
  c_w3: '100px',
  c_w4: '110px',
  c_w5: '120px',
  c_w6: '130px',
  c_w7: '140px',
  c_w8: '150px',
  c_w9: '160px',
  c_w10: '170px',
  c_w11: '180px',
  c_w12: '190px',
  opr_width1: '100px', // 列表操作列宽度，只有1个操作项
  opr_width2: '150px', // 列表操作列宽度，只有2个操作项
  opr_width3: '200px', // 列表操作列宽度，只有3个操作项
  opr_width4: '250px', // 列表操作列宽度，只有4个操作项
  opr_width6: '400px', // 列表操作列宽度，只有5个操作项
  opr_width8: '500px', // 列表操作列宽度，只有6个操作项

}